<template>
   <ul class="VinSearch">
        <li class="text">请输入车辆VIN码</li>
        <li class="content">
            <input v-model="vin" type="text" class="input" placeholder="请输入车辆行驶证中的VIN码"/>
            <img v-if="vin" src="../assets/images/icon-close.png" alt="" @click="cancel">
        </li>
        <li :class="['btn',vin?'active':'']" @click="searchVIN">确定</li>
   </ul>
</template>
<script>
    import { Toast } from 'vant';
    export default {
        data() {
            return {
                vin: ""
            }
        },
        watch:{
            vin(n){
                this.vin = n.toUpperCase();
            }
        },
        methods: {
            cancel(){
                this.vin = "";
            },
            searchVIN(){
                if(!this.vin) return;
                if(this.vin.length!=17) return  Toast('vin码输入有误，请重新验证');
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$get(`/api/sim/${this.vin}`).then(res => {
                    if (res.errcode == 0 && res.data && res.data.realNameAuthStatus == '0' && res.data.auth_redirect_url) {
                        Toast.clear();
                        location.replace(res.data.auth_redirect_url)
                    }else if (res.errcode == 0 && res.data && res.data.realNameAuthStatus == '1') {
                        Toast("您已实名认证");
                    }else{
                        Toast("您的车联网卡不需要实名认证");
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .VinSearch {
        padding: 22px;
        .text {
            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #383938;
        }
        .content {
            height: 48px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #f2f2f2;
            .input {
                flex: 1;
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #383938;
                outline: none;
                border: none;
                &::-webkit-input-placeholder{
                    color: #b3b3b3;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                }
            }
            img {
                width: 12px;
            }
        }
        .btn {
            position: fixed;
            bottom: 40px;
            left: 22px;
            right: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            background: #e6e6e6;
            border-radius: 1px;
            font-size: 20px;
            font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 600;
            color: #ffffff;
            color: #bbb;
            &.active {
                background: #b6862d;
                color: #fff;
            }
        }
    }
</style>